import React, { useState } from 'react';

function TextForm(props) {

    const handleUpclick = ()=>{
        let newText = text.toUpperCase();
        setText(newText)
    }

    const handleLowclick = ()=>{
        let newText = text.toLowerCase();
        setText(newText)
    }
    
    const handleClearclick = ()=>{
        let newText = '';
        setText(newText)
    }

    const handleCopy = ()=>{
        let text = document.getElementById('myBox');
        text.select ();
        navigator.clipboard.writeText(text.value);
        document.getSelection().removeAllRanges();
    }

    const handleOnChange = (event)=>{
        setText(event.target.value)
    }

    const [text, setText] = useState('')
     
    return (
        <>
            <div className="container my-3" style={{color: props.mode==='dark'?'white':'#042743'}}>
                <h1 className= "mb-3">Try TextUtils - World counter, Character counter</h1>
                <div className="mb-3">
                    <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'#1b2646':'white', color: props.mode==='dark'?'white':'#042743'}} id="myBox" rows="8"></textarea>
                </div>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleUpclick}> Convert to Uppercase </button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleLowclick}> Convert to Lowercase </button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleClearclick}> Clear </button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleCopy}> Copy Text</button>
            </div>
            <div className="container my-3" style={{color: props.mode==='dark'?'white':'#042743'}}>
                <h1>Your text summary</h1>
                <p>{text.split(" ").filter((element)=>{return element.length!==0}).length} words and  {text.length} characters</p>
                <p>You can read this in {0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} Minutes</p>
                <h2>Preview</h2>
                <p>{text.length>0?text:"Nothing to priview"}</p>
            </div>
        </>
    );
}

export default TextForm;